const { REGEX } = require("../constants");

const deriveOuterCodeSectorFromPostcode = (countryCode, postCode) => {
  if (countryCode === "GB" && postCode !== "") {
    postCode = postCode.replace(/\s/g, "").toUpperCase();

    if (postCode.match(REGEX.GB_POSTCODE_PATTERN)) {
      return postCode.substring(0, postCode.length - 2);
    }

    return postCode;
  } else if (countryCode === "IE" && postCode !== "") {
    postCode = postCode.replace(/\s/g, "").toUpperCase();

    if (postCode.match(/^[zZ]{2}(71|75)$/)) {
      return postCode + "0";
    } else if (postCode.match(/^[zZ]{2}(71|75)([ ]?0[aA]{2})?$/)) {
      return postCode.substring(0, postCode.length - 2);
    } else if (postCode.match(/^D\d$/)) {
      return "ZZ710";
    } else {
      return "";
    }
  }
  return "";
};

exports.getOuterSectorCode = (countryCode, postCode) => {
  const outerSectorCode = deriveOuterCodeSectorFromPostcode(
    countryCode,
    postCode
  );
  if (outerSectorCode) {
    return outerSectorCode;
  }
};

exports.isDomesticDelivery = (countryCode) => {
  return countryCode === "GB" || countryCode === "IE";
};
